import { atom, RecoilState } from 'recoil';
import { User } from 'api/models';

export const usersAtom: RecoilState<User[]> = atom<User[]>({
  key: 'usersAtom',
  default: [],
});
